import { useState } from 'react'

const hexToRgb = (hex) => {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}
const rgbToHex = (r, g, b) => {
  let hex = ((r << 16) | (g << 8) | b).toString(16);
  return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
}
const shadeColor = (color, percent) => {
  let [r, g, b] = hexToRgb(color);
  r = Math.round((r * (100 + percent)) / 100);
  g = Math.round((g * (100 + percent)) / 100);
  b = Math.round((b * (100 + percent)) / 100);
  r = (r < 255) ? r : 255;
  g = (g < 255) ? g : 255;
  b = (b < 255) ? b : 255;
  return rgbToHex(r, g, b);
}

const createShades = (color, count, darkness=0) => {
  let arr = [];
  //increse darkness in fibonacci series
  // const goldenRatio = 1.61803398875;
  for (let i = 0; i < count; i++) {
    // const fiboNumber = Math.round((Math.pow(goldenRatio, i) - Math.pow(1 - goldenRatio, i)) / Math.sqrt(5));
    arr.push(shadeColor(color,darkness));
    darkness = darkness + (i + 1) * 10;
    // darkness = darkness + fiboNumber * 10;
  }
  return arr;
}

const Shades = () => {
  const [color, setColor] = useState('#1042c0');
  const [darkColorCount, setDarkColorCount] = useState(2);
  const [lightColorCount, setLightColorCount] = useState(5);
  const [isValidColor, setIsValidColor] = useState(true);
  const count = darkColorCount + lightColorCount;

  const handleColorChange = (e) => {
    if (e.target.value.length !== 7) {
      setIsValidColor(false);
    }
    else {
      setIsValidColor(true);
    }
    setColor(e.target.value);
  }

  const [darkness, setDarkness] = useState(10);

  return (
    <div style={{ margin: "4rem 2rem" }}>
      <div>
        <input type="text" className='input-field input-content' defaultValue={color} style={{ color: `${color}` }} onChange={handleColorChange} />
      </div>
      {/* <input type="color" id="head" name="head"
           value="e66465"/>
    <label for="head">Head</label> */}
      {isValidColor ? <> <div style={{ height: "10vh", display: "grid", gridTemplateColumns: `repeat(${count},1fr)`, backgroundColor: { color } }}>
        <ColorPaletteChild showShades={true} count={count} color={color} />

      </div>
        <h2>Dark Shades</h2>

        <input type="text" className='input-field' defaultValue={lightColorCount} onChange={(e) => setLightColorCount(e.target.value)} /></> : <div>Invalid Color</div>}
      <div style={{ height: "10vh", display: "grid", gridTemplateColumns: `repeat(${count},1fr)` }}>
        <LightShades darkness={10} />

      </div>
      <h1>DarkShades</h1>
      <div>
        <input type="range" id="volume" name="volume"
          value={darkness}
          min="0" max="100" onChange={(e) => setDarkness(e.target.value)} />
        <label htmlFor="volume">Volume</label>
      </div>
        <p>{darkness}</p>
      <div style={{ height: "10vh", display: "grid", gridTemplateColumns: `repeat(${lightColorCount},1fr)` }}>
        <LightShades darkness={-darkness} />
      </div>
    </div>
  )
}
function ColorPaletteChild({ color, showShades, count }) {
  let arr = [];
  for (let i = 0; i < count; i++) {
    arr.push(<div style={{ backgroundColor: `${shadeColor(color, i * 10)}`, display: `${showShades ? "block" : "none"}` }} key={i}></div>);
  }
  return arr
}

function LightShades({ darkness }) {
  let arr = [];

  createShades('#1042c0', 5, darkness).forEach((color, i) => {
    arr.push(<div style={{ backgroundColor: `${color}` }} key={i}></div>);
  }
  )
  return arr


}


export default Shades